namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_code_panel, {
		gap: $mol_gap.space,

		Run_icon: {
			width: '1.4rem',
		},

		Autorun_enabled: {
			'[mol_check_checked]': {
				true: {
					color: $mol_theme.current,
				},
			},
		},

		No_crdt_label: {
			font: {
				size: '.75rem',
			},
			color: $mol_theme.text,
			justify: {
				content: 'center',
			},
		},
	} )

}
